import { render, staticRenderFns } from "./HomeTHSN.vue?vue&type=template&id=33b48ce9"
import script from "./HomeTHSN.vue?vue&type=script&lang=js"
export * from "./HomeTHSN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports